export const getUrlParam = (name: string, searchStr?: any): string | null => {
  const { search, hash } = window.location;

  const hashSearch = hash.split('?')[1];

  searchStr = searchStr || search.substr(1) || hash.split('?')[1] || '';

  if (hashSearch) searchStr += `${searchStr ? '&' : ''}${hashSearch}`;
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  let r = searchStr.match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};

// 获取orgflag 平台码 用户id,如果获取过一次就直接从这里拿，不走拿缓存等，节约资源
type keyType =
  | 'agentId'
  | 'token'
  | 'dragoncode'
  | 'language'
  | 'channel'
  | 'cipId'
  | 'batchCode'
  | 'agreementCode'
  | 'projectId';
interface GetValueFnOption {
  // 是否需要存缓存，触发条件如果url可以获取到值并且的不等于缓存的值，
  saveStorage?: boolean;
  // 缓存的类型，local || session
  storageType?: 'local' | 'session';
  // 存缓存的key，默认等于key
  saveKey?: string;
  // 默认值，当url和缓存拿不到值，默认复制这个
  defaultVal?: any;
}
interface GetValueFn {
  (key: keyType, option?: GetValueFnOption): string;
}
/**
 *  获取orgflag 平台码 用户id,如果获取过一次就直接从这里拿，不走拿缓存等，节约资源
 * @param key
 * @param option @GetValueFnOption
 * @returns string
 */
export const getValue: GetValueFn = (key: keyType, option = {}) => {
  const {
    saveStorage = true,
    storageType = 'local',
    saveKey = key,
    defaultVal = '',
  } = option || {};
  const storageFns = {
    local: localStorage,
    session: sessionStorage,
  };
  const storage = storageFns[storageType];
  const urlVal = getUrlParam(key);
  const storeVal = storage.getItem(saveKey);
  const value = urlVal || storeVal || defaultVal;
  if (saveStorage && urlVal && urlVal !== storeVal) {
    storage.setItem(key, value);
  }
  return value;
};

// cip信息
interface CipParams {
  token: string;
  batchCode?: string;
  projectId?: string;
  agreementCode?: string;
}
export const getCipParams = () => {
  // cip的token是特殊的，和之前不一样
  const storageToken = localStorage.getItem('token') || '';
  const token = storageToken.split(' ')[1] || '';
  // 要么有 projectId agreementCode  要么有 batchCode
  const urlProjectId = getUrlParam('projectId');
  const urlAgreementCode = getUrlParam('agreementCode');

  if (urlProjectId && urlAgreementCode) {
    sessionStorage.removeItem('batchCode');
  } else {
    sessionStorage.removeItem('projectId');
    sessionStorage.removeItem('agreementCode');
  }
  const batchCode = getValue('batchCode', { storageType: 'session' });
  const projectId = getValue('projectId', { storageType: 'session' });
  const agreementCode = getValue('agreementCode', { storageType: 'session' });
  const params: CipParams = { token };
  if (batchCode) params.batchCode = batchCode;
  if (projectId && agreementCode) {
    params.projectId = projectId;
    params.agreementCode = agreementCode;
  }
  return params;
};

// 获取
export const getAgentId = () => {
  return getValue('agentId');
};

// 获取当前语种 英文
export const getLanguage = () => {
  let language = getUrlParam('language');
  if (!language) language = localStorage.getItem('language');
  if (!language) language = 'zh-cn';
  return language;
};

// 获取showTopBar
export const getShowTopBar = () => {
  let showTopBar = getUrlParam('showTopBar');
  showTopBar = showTopBar || localStorage.getItem('showTopBar');
  if (showTopBar === 'false') return false;
  return true;
};
